import { 
  SiInstagram, 
  SiGithub, 
  SiLinkedin, 
  SiFacebook, 
  SiX, 
  SiDiscord, 
  SiTwitch, 
  SiSteam,
  SiXbox,
  SiBattledotnet,
  SiNintendo,
  SiEpicgames 
} from 'react-icons/si';
import { BsHeadsetVr } from 'react-icons/bs';

export const socialMediaOptions = [
    { label: 'Instagram', value: 'Instagram', icon: SiInstagram, color: '#E4405F' },
    { label: 'Github', value: 'Github', icon: SiGithub, color: '#181717' },
    { label: 'Linkedin', value: 'Linkedin', icon: SiLinkedin, color: '#0A66C2' },
    { label: 'Facebook', value: 'Facebook', icon: SiFacebook, color: '#1877F2' },
    { label: 'X', value: 'X', icon: SiX, color: '#000000' },
    { label: 'Discord', value: 'Discord', icon: SiDiscord, color: '#5865F2' },
    { label: 'Twitch', value: 'Twitch', icon: SiTwitch, color: '#9146FF' },
    { label: 'Steam', value: 'Steam', icon: SiSteam, color: '#000000' },
    { label: 'Xbox', value: 'Xbox', icon: SiXbox, color: '#107C10' },
    { label: 'Battle.net', value: 'Battle.net', icon: SiBattledotnet, color: '#00AEFF' },
    { label: 'Nintendo', value: 'Nintendo', icon: SiNintendo, color: '#E60012' },
    { label: 'Epic Games', value: 'Epic Games', icon: SiEpicgames, color: '#000000' },
    { label: 'VR', value: 'VR', icon: BsHeadsetVr, color: '#212121' },
];